angular.module('lsnBase.deprecated.models')
  .factory('BonusMalusDataObjectModel', ['LsnBonusMalusDataObjectModelV1',
    function(LsnBonusMalusDataObjectModelV1) {
      return LsnBonusMalusDataObjectModelV1;
    }
  ]);